/*
 *  File: search.component.ts
 ********************************************************************
 *  Date        Author                 Changes
 ********************************************************************
 *  02/01/18    Dhanalakshmi Lolugu    Created
 ********************************************************************
 * Copyright (c) 2009 Synapse Group, Inc.
 * 225 High Ridge Park, Stamford, Connecticut, 06905-1325, U.S.A.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of
 * Synapse Group, Inc. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with Synapse Group, Inc.
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from '../services/search.service';
import { TokenService } from '../services/token.service';
import { environment } from '../../environments/environment';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CsaService } from '../services/csa.service';
import { Observable } from 'rxjs/Observable';
//import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/retry';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: []
})
/**
 *
 * @author dlolugu1271
 * @description This component class which describes the
 * search functionality within the self service.
 * 
 */
export class SearchComponent implements OnInit {
  model: any = {};

  private itemKey: string;
  private email: string;
  private loading: boolean = true;
  private itemKeyValue: any;

  private searchOrderData: any;
  private retrieveOrderData: any;
  private errorMsg: string;
  private searchForm: FormGroup;
  private appconfig = environment.appconfig;
  private appextconfig = environment.appextconfig;
  private commonSysErr: string="";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private searchService: SearchService,
    private tokenService: TokenService
  ) { }

  /**
   *
   * @author dlolugu1271
   * @description This method will get the IDS token from servcie
   * and initialize the search form.
   * 
   */
  ngOnInit() {
    try {
      if (document.referrer && (document.referrer.includes("theconnoisseurclub.com") || document.referrer.includes("skyguideclub.com")
        || document.referrer.includes("golfplayersclub.com") || document.referrer.includes("tlelitetraveler.com")) ) {
        this.router.navigate(['/customer-service'], { relativeTo: this.route });
      }
      localStorage.clear();
      this.tokenService.login();
      //localStorage.setItem('token', 'b93aaf41-35a2-4b98-b13d-8845e378c640');
      this.searchForm = new FormGroup({
        itemKey: new FormControl('', [
          Validators.required,
          Validators.pattern(this.appconfig.search.subsid_pattern)
        ]),
        email: new FormControl('', [
          Validators.required,
          Validators.pattern(this.appconfig.search.email_pattern)
        ])
      });
    } catch (error) {
      this.router.navigate(['/error'], { relativeTo: this.route });
    }
  }

 /**
   *
   * @author dlolugu1271
   * @description This method will checks the given from
   * control is valid when user enters from UI and returns
   * true if no errors else returns false.
   * @augments field
   * @returns boolean
   * 
   */
  isFieldValid(field: string) {
    return !this.searchForm.get(field).valid && (this.searchForm.get(field).touched
      || this.searchForm.get(field).dirty);
  }

  /**
   *
   * @author dlolugu1271
   * @description This method validateAllFormFields validates
   * the form controls.
   * @augments formGroup
   * @returns boolean
   * 
   */
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  /**
   *
   * @author dlolugu1271
   * @description This method searchOrder invokes the service if the 
   * valid form fileds are provided and renders the response by 
   * routing to cancel page. If the form is invalid renders
   * error messages without APIs being invoked. If there is no data
   * or any errors it will show the corresponding error message to the UI.
   * 
   */
  searchOrder() {
    try {
      localStorage.removeItem('subscription');
      localStorage.removeItem('itemKey');
      this.errorMsg = '';
      if (!this.searchForm.valid) {
        this.validateAllFormFields(this.searchForm);
        return;
      }
      this.loading = false;

      this.searchService.itemKey = this.itemKey;
      this.searchService.email = this.email;

      if (localStorage.getItem('token') && localStorage.getItem('token') != "") {
        this.searchService.searchOrder()
          //.timeout(environment.appextconfig.api_timeout_limit)
          //.retry(environment.appextconfig.api_retry_limit)
          .subscribe(
          res => {
            if (res == null || res == undefined) {
              this.loading = true;
              this.errorMsg = 'Null response from customerSearch API';
              return;
            }
            this.searchOrderData = res;
            if (this.searchOrderData.hasErrors) {
              this.loading = true;
              this.errorMsg = this.searchOrderData.statusDesc[0];
              return;
            } else {
                  let partnerOrderNo = this.searchOrderData.customers[0].partnerOrderNo;
                  if (partnerOrderNo != undefined && partnerOrderNo != "") {
                    this.fetchSubsDetails(partnerOrderNo,
                      this.searchOrderData.customers[0].partnerName,
                      this.searchOrderData.customers[0].clientName,
                      this.searchOrderData.customers[0].storeName,
                      this.searchOrderData.customers[0].configId);
                  } else {
                    this.loading = true;
                    this.errorMsg = 'No Partner Id found';
                    return;
                  }
            }
          },
          error => {
            this.loading = true;
            this.commonSysErr = 'Unable to retrieve response from customerSearch API';
            //console.error('**Error**', error);
            this.router.navigate(['/error'], { relativeTo: this.route });
          });
      } else {
        this.loading = true;
        this.commonSysErr = 'Unable to get token from API'
        //console.error('**Error**', this.errorMsg);
        this.router.navigate(['/error'], { relativeTo: this.route });
      }
    } catch (error) {
      this.router.navigate(['/error'], { relativeTo: this.route });
    }
  }
 /**
   *
   * @author dlolugu1271
   * @description This method fetchSubsDetails retrieves the response
   * from search service retrieve all for the given partner order Id.
   * if the response is valid then it sets the contents for cancel
   * else renders the error message
   * @augments id
   * 
   */
  fetchSubsDetails(id:string, partnerName: string,
    clientName: string,
    storeName: string,
    configId: string) {
    localStorage.setItem('itemKey', this.itemKey);
    localStorage.removeItem('subscription');
    this.loading = false;
    this.searchService.retrieveDeliveryInfo(id, partnerName, clientName, storeName, configId)
      //.timeout(environment.appextconfig.api_timeout_limit)
      //.retry(environment.appextconfig.api_retry_limit)
      .subscribe(
      res => {
        if (res == null || res == undefined) {
          this.loading = true;
          this.errorMsg = 'Null response from retriveAll API';
          return;
        }
        this.retrieveOrderData = res;
        if (this.retrieveOrderData.hasErrors) {
          this.loading = true;
          this.errorMsg = this.searchOrderData.statusDesc[0];
          return;
        } else {
          let subscription = (this.retrieveOrderData.subscriptions).find(item => item.partnerOrderNo === id);
          if (subscription) {
            subscription['config'] = {
              "configId": configId,
              "partnerName": partnerName,
              "clientName": clientName,
              "storeName": storeName};
            let lineItemRes = (subscription.productLineitems).find(li => li.itemKey === this.itemKey);
            if (lineItemRes) {
              localStorage.setItem('subscription', JSON.stringify(subscription));
            } else {
              this.loading = true;
              this.errorMsg = 'No Customer details found';
            }
          } else {
            this.loading = true;
            this.errorMsg = 'No Customer details found';
          }
        }
        if (!this.errorMsg) {
          this.router.navigate(['/cancel-item'], { relativeTo: this.route });
        }
      },
      error => {
        //console.error('**Error - fetchSubsDetails**', error);
        this.loading = true;
        this.commonSysErr = 'Unable to retrieve response from Retrieve All API';
        this.router.navigate(['/error'], { relativeTo: this.route });
      }
      );
  }
}



// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/search/search.component.ts